// route.js 
import { createRouter, createWebHashHistory } from 'vue-router'
import LoginPage from '@/views/LoginPage.vue'
import LayoutPage from '@/views/LayoutPage.vue'
import SysFunc from '@/views/SysFunc.vue'
import RoleSet from '@/views/RoleSet.vue'
import CompSet from '@/views/CompSet.vue'
import OutletUser from '@/views/OutletUser.vue'
import MyData from '@/views/MyData.vue'
import CompData from '@/views/CompData.vue'
import LogEvent from '@/views/LogEvent.vue'
import OrderTracking from '@/views/OrderTracking.vue'
import ApiTest from '@/views/ApiTest.vue'
import RemittanceRecord from '@/views/RemittanceRecord.vue'
import RemittanceList from '@/views/RemittanceList.vue'
import DepositList from '@/views/DepositList.vue'
import OrderRecord from '@/views/OrderRecord.vue'
import OrderFee from '@/views/OrderFee.vue'
import DocSet from '@/views/DocSet.vue'
import TrackingPage from '@/views/TrackingPage.vue'
import LogisticsFee from '@/views/LogisticsFee.vue'
import DeliveryOrders from '@/views/DeliveryOrders.vue'

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            components: { MainView: LoginPage }
        },
        {
            path: '/tracking',
            components: { MainView: TrackingPage },
            meta: {
                title: '包裹查詢'
            }
        },
        {
            path: '/Home',
            components: {
                MainView: LayoutPage
            },
            children: [
                {
                    path: '',
                    components: {
                        SysFunc: SysFunc,
                        RoleSet: RoleSet,
                        CompSet: CompSet,
                        OutletUser: OutletUser,
                        MyData: MyData,
                        CompData: CompData,
                        LogEvent: LogEvent,
                        OrderTracking: OrderTracking,
                        ApiTest: ApiTest,
                        RemittanceRecord: RemittanceRecord,
                        RemittanceList: RemittanceList,
                        DepositList: DepositList,
                        OrderRecord: OrderRecord,
                        OrderFee: OrderFee,
                        DocSet: DocSet,
                        LogisticsFee: LogisticsFee,
                        DeliveryOrders: DeliveryOrders,
                    }
                }
            ]
        }
    ],
});

router.afterEach((to) => {
    document.title = to.meta.title || 'METE_WEB';
});

export default router;